import { POOL_CAPACITY } from '../constants';
import { IndexPool } from './IndexPool';

export class BossPartPool {
  readonly indices = new IndexPool(POOL_CAPACITY.bossParts);
  readonly x = new Float32Array(POOL_CAPACITY.bossParts);
  readonly y = new Float32Array(POOL_CAPACITY.bossParts);
  readonly angle = new Float32Array(POOL_CAPACITY.bossParts);
  readonly hp = new Float32Array(POOL_CAPACITY.bossParts);
  readonly maxHp = new Float32Array(POOL_CAPACITY.bossParts);
  readonly radius = new Float32Array(POOL_CAPACITY.bossParts);
  readonly partType = new Uint8Array(POOL_CAPACITY.bossParts);
  readonly vulnerable = new Uint8Array(POOL_CAPACITY.bossParts);
  readonly visible = new Uint8Array(POOL_CAPACITY.bossParts);
  readonly lastAttackId = new Uint32Array(POOL_CAPACITY.bossParts);

  spawn(partType: number, x: number, y: number, hp: number, radius: number, vulnerable = true): number {
    const index = this.indices.acquire();
    if (index < 0) return -1;
    this.partType[index] = partType;
    this.x[index] = x;
    this.y[index] = y;
    this.angle[index] = 0;
    this.hp[index] = hp;
    this.maxHp[index] = hp;
    this.radius[index] = radius;
    this.vulnerable[index] = vulnerable ? 1 : 0;
    this.visible[index] = 1;
    this.lastAttackId[index] = 0;
    return index;
  }

  reset(): void {
    this.indices.reset();
  }
}
